import Isotope from "isotope-layout"; // Import Isotope library

class IsoFilter {
  constructor(containerElement, filterOptions = {}) {
    if (!containerElement) {
      console.error("IsoFilter: Container element not provided.");
      return;
    }
    this.containerEl = containerElement;
    this.filterOptions = filterOptions;

    // Default properties
    this.filterString = "*";
    this.regionFilters = [];
    this.categoryFilters = [];
    this.current_filter = null; // Consider renaming to currentFilter
    this.current_tags = []; // Consider renaming to currentTags
    this.tagBoxEl = document.getElementById("tagbox"); // Assumes unique ID 'tagbox'
    this.filterLinks = []; // Stores filter link elements

    this._initFilter();
  }

  _initFilter() {
    if (this.containerEl) {
      // Initialize Isotope with vanilla JS options
      this.isoInstance = new Isotope(this.containerEl, {
        itemSelector: this.filterOptions.itemClass || ".item", // Provide default
        layoutMode: "fitRows",
      });
    }
    // this.usaMap = this.filterOptions.usaMap; // Keep if needed, but interaction might need rework w/o jQuery
  }

  addLinkWatcher(linkElement) {
    this.filterLinks.push(linkElement);
  }

  removeTag(filterToRemove) {
    const categoryIndex = this.categoryFilters.indexOf(filterToRemove);
    if (categoryIndex !== -1) {
      this.removeCategoryFilter(filterToRemove);
      this.deactivateLink(filterToRemove); // Corrected typo: deactiveLink -> deactivateLink
    }

    const regionIndex = this.regionFilters.indexOf(filterToRemove);
    if (regionIndex !== -1) {
      this.removeRegionFilter(filterToRemove);
      // If usaMap interaction is kept, it needs rework:
      // this.usaMap?.deactivateRegion(filterToRemove.slice(1).split('-')[0]);
    }
    this.setFilters(); // Update isotope after removing tag
  }

  deactivateLink(classToRemove) {
    const linkToDeactivate = this.filterLinks.find(
      (link) => link.dataset.filter === classToRemove
    );
    if (linkToDeactivate) {
      linkToDeactivate.classList.remove("active");
      linkToDeactivate.setAttribute("data-activelink", "false");
    }
    // Remove the link from the watcher array?
    // this.filterLinks = this.filterLinks.filter(link => link !== linkToDeactivate);
  }

  _setTagCloseLink(closeButtonElement) {
    // Use instance binding or arrow function for correct 'this'
    const handleCloseClick = (event) => {
      const filterToRemove = event.target.dataset.filterclose;
      if (filterToRemove) {
        this.removeTag(filterToRemove);
        event.target.closest("li.filterbox-tag")?.remove(); // Remove the whole tag li
      }
    };
    closeButtonElement.addEventListener("click", handleCloseClick);
    // Consider storing the listener reference if you need to remove it later
  }

  _setTags() {
    if (!this.tagBoxEl) return;
    this.tagBoxEl.innerHTML = ""; // Clear existing tags
    this.current_tags.forEach((tag, index) => {
      const tagName = this._normalizeTag(tag);
      const tagLi = document.createElement("li");
      tagLi.className = "filterbox-tag";
      tagLi.innerHTML = `
        <span>${tagName}</span>
        <i class='fa fa-times filterbox-tag-close' id='close${index}' data-filterclose='${tag}'></i>
      `;
      this.tagBoxEl.appendChild(tagLi);
      const closeButton = tagLi.querySelector(`#close${index}`);
      if (closeButton) {
        this._setTagCloseLink(closeButton);
      }
    });
  }

  _normalizeTag(tag) {
    let normalizedTag = "";
    // Remove leading '.' and split by '-'
    const parts = tag.substring(1).split("-");
    const unfilteredTag = parts[0];
    const lowercaseWords = unfilteredTag.split("_");
    const isNumber = !isNaN(parseInt(lowercaseWords[0], 10));

    if (!isNumber) {
      normalizedTag = lowercaseWords
        .map((word, index) => {
          if (word.toLowerCase() === "and") {
            return word;
          }
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    } else {
      normalizedTag = lowercaseWords.join(" - ") + " Days";
    }
    return normalizedTag;
  }

  _filtersAsTagsArray() {
    // Combine region and category filters into current_tags
    this.current_tags = [...this.regionFilters, ...this.categoryFilters];
  }

  setFilters() {
    const rfl = this.regionFilters.length;
    const cfl = this.categoryFilters.length;

    if (rfl <= 0 && cfl <= 0) {
      this.filterString = "*";
    } else if (rfl > 0 && cfl > 0) {
      this._combineRegionWithCategory();
    } else if (rfl > 0) {
      this._buildFilterString(this.regionFilters);
    } else {
      // cfl > 0
      this._buildFilterString(this.categoryFilters);
    }

    if (this.isoInstance) {
      this.isoInstance.arrange({ filter: this.filterString });
    }
    this._filtersAsTagsArray();
    this._setTags();
  }

  _combineRegionWithCategory() {
    const mixedArray = [];
    this.regionFilters.forEach((regionfilter) => {
      this.categoryFilters.forEach((categoryfilter) => {
        // Isotope combinators usually use the class directly, no '.' needed? Check Isotope docs.
        // Assuming simple concatenation works for filter logic: '.region.category'
        mixedArray.push(regionfilter + categoryfilter);
      });
    });
    this._buildFilterString(mixedArray);
  }

  _buildFilterString(array) {
    // Isotope filter string is usually a comma-separated list of selectors
    this.filterString = array.join(", ");
  }

  addRegionFilter(filterparam) {
    if (!this.regionFilters.includes(filterparam)) {
      this.regionFilters.push(filterparam);
    }
  }

  removeRegionFilter(filterparam) {
    this.regionFilters = this.regionFilters.filter((f) => f !== filterparam);
  }

  addCategoryFilter(filterparam) {
    if (!this.categoryFilters.includes(filterparam)) {
      this.categoryFilters.push(filterparam);
    }
  }

  removeCategoryFilter(filterparam) {
    this.categoryFilters = this.categoryFilters.filter(
      (f) => f !== filterparam
    );
  }
}

export default IsoFilter;
